// @flow

import type { TransportType, GoalType, ConversionType } from '../';

type FacebookOptions = {
  pixelId: string
};

export default function configure(options: FacebookOptions): TransportType {
  const { pixelId } = options;

  if (!pixelId) {
    return {};
  }

  const doc = document;
  const win = window;

  if (!win.fbq) {
    // $FlowFixMe
    (function(f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(win, doc, 'script', '//connect.facebook.net/en_US/fbevents.js');
  } else if (__DEV__) {
    console.warn('[trackr] Facebook Events has already been loaded');
  }

  win.fbq('init', pixelId);

  return {
    pageview(): void {
      win.fbq('track', 'PageView');
      const pathname = win.location.pathname;
      if (/^\/vis\//.test(pathname)) {
        win.fbq('track', 'ViewContent', {
          content_ids: [pathname.replace('/vis/', '')],
          content_type: 'product',
          product_catalog_id: '1097830360410598'
        });
      }
    },
    goal(options: GoalType): void {
      if (typeof options === 'number' || typeof options === 'string') {
        // ...
      } else if (options.name === 'search') {
        const data =
          options.data && options.data.q
            ? { search_string: options.data.q }
            : undefined;
        win.fbq('track', 'Search', data);
      } else if (
        [
          'CompleteRegistration',
          'InitiateCheckout',
          'AddPaymentInfo',
          'Lead'
        ].includes(options.name)
      ) {
        win.fbq('track', options.name);
      }
    },
    conversion(options: ConversionType): void {
      const { product, currency = 'DKK' } = options;
      const value = product.value;

      win.fbq('track', 'Purchase', {
        value,
        currency,
        content_name: product.code
      });
    }
  };
}

// View content	fbq('track', 'ViewContent');
// Search	fbq('track', 'Search');
// Add to cart	fbq('track', 'AddToCart');
// Add to wishlist	fbq('track', 'AddToWishlist');
// Initiate checkout	fbq('track', 'InitiateCheckout');
// Add payment info	fbq('track', 'AddPaymentInfo');
// Make purchase	fbq('track', 'Purchase', {value: 0.00, currency: 'USD'});
// Lead	fbq('track', 'Lead');
// Complete registration	fbq('track', 'CompleteRegistration');
